import axios from "axios";
import CryptoJS from 'crypto-js';
import base64 from "crypto-js/enc-base64";
import store from "@/store";
import _ from "lodash";
import moment from "moment";
let cancelList = {};
const encrypt = (text) => { //加密
  if (typeof (text) != "string") {
    text = JSON.stringify(text);
  }
  const ivcode = moment().format("x").substr(13);
  const key = base64.parse(process.env.VUE_APP_KEY);
  const iv = CryptoJS.enc.Latin1.parse(ivcode);
  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  // moment().format("x");
  return btoa(JSON.stringify({
    iv: ivcode,
    value: encrypted.toString(),
    mac: CryptoJS.SHA512(iv).toString()
  }));
};
const Token_crpt = () => {
  const Api_Token = localStorage.Authorization;
  const company = store.state.system.company;
  const Auth = {
    T: Api_Token,
    C: company
  };
  const s = encrypt(Auth);
  return "Bearer " + s;
}
const http = {
  "get"(path, data, config = {}, cancelname = null) {
    const isloadshow = !config.hide;
    const transForm = {
      transformRequest: [(data, headers) => {
        if (isloadshow) {
          // store.commit("publicData/startLoading");
        }
        return data;
      }],
      transformResponse: [(data) => {
        if (isloadshow) {
          // store.commit("publicData/endLoading");
        }
        let redata = data;
        if (typeof (data) == "string") {
          data = JSON.parse(data);
        }
        return data;
      }]
    }

    delete config.hide;
    config.SameSite = "Strict";

    if (config.headers) {
      if (localStorage.Authorization) {
        config.headers['Authorization'] = Token_crpt();
      }
    } else {
      // "Bearer " + (sessionStorage.Authorization)
      if (localStorage.Authorization) {
        config.headers = {
          Authorization: Token_crpt()
        }
      }
    }
    config.headers = config.headers || {};
    console.log(store.state.system.company);
    config.headers.Company = store.state.system.company;
    if (cancelname && cancelList[cancelname]) {
      cancelList[cancelname]();
    }

    let tmp = [];
    data = (data || {});

    _.forEach(data, (item, keys) => {
      const val = typeof (item) == "string" || typeof (item) == "number" ? item : (item ?
        item.join(
          ",") : "");
      tmp.push(keys + "=" + val);
    });
    const CancelToken = axios.CancelToken;
    let cancel;
    const result = axios({
      method: 'get',
      url: path + (tmp.length > 0 ? "?" + tmp.join(
        "&") : ""),
      baseURL: process.env.VUE_APP_PATH + "/",
      data: data,
      responseType: 'json',
      cancelToken: new CancelToken(c => { //強行中斷請求要用到的
        (cancelname) ? cancelList[cancelname] = c: "";
      }),
      ...transForm,
      ...config
    });
    result.catch((thrown) => {});
    return result;
  },
  "post"(path, data, config = {}, cancelname = null) {
    const isloadshow = !config.hide;
    const transForm = {
      transformRequest: [(data, headers) => {
        const ta = encrypt(data);
        if (isloadshow) {

        }
        if (config.headers && config.headers['Content-Type'] == "multipart/form-data") {
          return data;
        }
        // return data;
        return JSON.stringify({
          data: ta
        });
      }],
      transformResponse: [(data) => {
        if (isloadshow) {}
        if (typeof (data) == "string") {
          data = JSON.parse(data);
        }
        return data;
      }]
    }
    delete config.show;
    config.SameSite = "Strict";
    if (config.headers) {
      if (localStorage.Authorization) {
        config.headers['Authorization'] = Token_crpt();
      }
    } else {
      if (localStorage.Authorization) {
        config.headers = {
          Authorization: Token_crpt()
        }
      }
    }
    config.headers = config.headers || {};
    config.headers.Company = store.state.system.company;
    if (cancelname && cancelList[cancelname]) {
      cancelList[cancelname]();
    }
    const CancelToken = axios.CancelToken;

    // const result = axios.post(path,data,{
    //   ...config,
    //   baseURL: process.env.VUE_APP_PATH + "/",
    //   cancelToken: new CancelToken(c => { //強行中斷請求要用到的
    //     (cancelname) ? cancelList[cancelname] = c: "";
    //   }),
    //   ...transForm
    // });
    const result = axios({
      method: 'post',
      url: path,
      baseURL: process.env.VUE_APP_PATH + "/",
      data: data,
      responseType: 'json',
      cancelToken: new CancelToken(c => { //強行中斷請求要用到的
        (cancelname) ? cancelList[cancelname] = c: "";
      }),
      ...transForm,
      ...config
    });

    result.catch((thrown) => {
      if (thrown.response) {

      }
    })
    return result;
  }
}

export default {
  ...http,
  encrypt: encrypt,
}
